import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { queryParser } from '@applyft-web/utils';
import {
  getUserInfo,
  getUserLocation,
  selectPaymentSettingsStatus,
  selectUserLocation,
} from '../store/signup';

export const useRemarketingAuth = (enabled: boolean = false): boolean => {
  const dispatch = useDispatch();
  const { search } = useLocation();
  const navigate = useNavigate();
  const status = useSelector(selectPaymentSettingsStatus);
  const userLocation = useSelector(selectUserLocation);
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    getUserLocation()(dispatch);

    if (!enabled) return;
    const { t } = queryParser(search);

    if (t) {
      getUserInfo(t)(dispatch);
    } else {
      navigate('/');
    }
  }, [enabled, dispatch, search, navigate]);

  useEffect(() => {
    if (userLocation === undefined) return;

    if (!enabled) {
      setIsSuccess(true);
      return;
    }

    if (status === 'success') {
      setIsSuccess(true);
    } else if (status) {
      navigate('/');
    }
  }, [enabled, status, userLocation, navigate]);

  return isSuccess;
};
